// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChartPie as RawChartPie } from "lucide-react";
export const ChartPie = /* @__PURE__ */ createIcon(RawChartPie, "ChartPie", 2);
